import {useIsFetching, useIsMutating} from '@tanstack/react-query';

const QueryGlobalLoader = () => {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  const showLoader = !!isFetching || !!isMutating;

  if (!showLoader) return null;

  return (
    <div className="fixed top-0 left-0 z-50 w-full">
      <div className="relative h-1 overflow-hidden bg-mint-100">
        <div className="absolute left-0 h-full w-full animate-[pulse_1.5s_ease-in-out_infinite] bg-mint-500"></div>
      </div>
    </div>
  );
};

export default QueryGlobalLoader;
